import type { HTMLAttributes } from "react";

import { Spinner } from "@alpacahq/ui/old";

interface FullScreenSpinnerProps extends HTMLAttributes<HTMLDivElement> {}

export const FullScreenSpinner = (props: FullScreenSpinnerProps) => (
  <div className="absolute top-0 left-0 z-[999999] flex h-screen w-screen items-center justify-center bg-white/50 py-4 backdrop-blur-sm backdrop-filter">
    <Spinner {...props} />
  </div>
);
